import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; 

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Shambhu Cabs - Terms & Conditions</title>
        <meta name="description" content="Terms & Conditions of Shambhu Cabs" />
      </Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3>Terms & Conditions</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All cab bookings are subject to availability and will be confirmed after successful payment or confirmation from our team.</p>

                <p><b className="highlight">2. Payment:</b> Payments can be made online, through UPI, or in cash to the assigned driver. Advance payment may be required for outstation bookings.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Cancellations or changes to bookings must follow Shambhu Cabs’ cancellation policy. Charges may apply based on timing.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers must carry valid ID proof and provide accurate pickup details. Incorrect information may cause delays.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Only limited baggage is allowed depending on the cab type. Excess baggage may require an upgraded vehicle and additional charges.</p>

                <p><b className="highlight">6. Travel Insurance:</b> Shambhu Cabs does not provide insurance. Passengers are encouraged to arrange personal travel insurance if required.</p>

                <p><b className="highlight">7. Safety Regulations:</b> Passengers must follow all safety instructions and wear seatbelts during travel.</p>

                <p><b className="highlight">8. Changes to Trip:</b> Route changes, additional stops, or extended hours may incur extra charges.</p>

                <p><b className="highlight">9. Refusal of Service:</b> We reserve the right to refuse service in cases of misconduct, intoxication, or unsafe behavior.</p>

                <p><b className="highlight">10. Jurisdiction:</b> All disputes will fall under the legal jurisdiction of the respective region in India.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Customers can book a cab via phone, website, mobile app, or WhatsApp.</p>
                <p><b className="highlight">Customer Support:</b> Our team is available to assist with any inquiries, corporate bookings, or special travel requirements.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Charges:</b> Refunds depend on the type of booking and the time of cancellation.</p>
                <p><b className="highlight">Refund Timeline:</b> Refunds will be processed within the standard banking timeline to the original payment method.</p>
                <p><b className="highlight">No-Show Policy:</b> No-shows without prior cancellation may not be eligible for a refund.</p>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any questions regarding our policies, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919819399797">+91 9819399797</a></li>
              <li><b>Email:</b> <a href="mailto:bookings@shambhucabs.com">bookings@shambhucabs.com</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
